import type { IntlShape } from 'react-intl'
import { getUnit, kmToMiles } from 'lib/geo/distanceUnits'

export function getSearchDistanceLabel(intl: IntlShape, searchTargetLabel: string, distanceMeters: number, regionCode: string) {
  const km = distanceMeters / 1000
  const unit = getUnit(regionCode)
  const unitDistance = unit === 'km' ? km : kmToMiles(km)
  const precision = km < 0.5 ? 2 : 1
  const displayNumber = unitDistance.toFixed(precision)

  if (unit === 'km') {
    return intl.formatMessage(
      {
        id: 'BTfbhRMNGNl7baHqHNWN',
        defaultMessage: '{distance} km from {target}',
        description: 'Distance in kilometres from a search target location',
      },
      { distance: displayNumber, target: searchTargetLabel },
    )
  }

  return intl.formatMessage(
    {
      id: 'VGL3rPH05wVMwLwUxzvR',
      defaultMessage: '{distance} mi from {target}',
      description: 'Distance in miles from a search target location in the offer listing section',
    },
    { distance: displayNumber, target: searchTargetLabel },
  )
}
